import * as types from '../actions/types';

const initialState = {
  // Main page state (Plan vs Actual for selected APS)
  selectedAPS: '',
  dataList: [],
  totalCount: 0,
  currentPage: 1,

  // Customer Detail Page state
  customerDetailPage: {
    apsCode: '',
    month: '',
    searchField: '',
    searchValue: '',
    currentPage: 1,
    dataList: [],
    totalCount: 0
  }
};

const targetAchievementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SELECTED_APS:
      return {
        ...state,
        selectedAPS: action.payload.selectedAPS,
        dataList: action.payload.dataList,
        totalCount: action.payload.totalCount,
        currentPage: action.payload.currentPage
      };

    case types.CLEAR_SELECTED_APS:
      return {
        ...state,
        selectedAPS: '',
        dataList: [],
        totalCount: 0,
        currentPage: 1
      };

    case types.SET_CUSTOMER_DETAIL_STATE:
      return {
        ...state,
        customerDetailPage: {
          apsCode: action.payload.apsCode,
          month: action.payload.month,
          searchField: action.payload.searchField,
          searchValue: action.payload.searchValue,
          currentPage: action.payload.currentPage,
          dataList: action.payload.dataList,
          totalCount: action.payload.totalCount
        }
      };

    case types.CLEAR_CUSTOMER_DETAIL_STATE:
      return {
        ...state,
        customerDetailPage: {
          apsCode: '',
          month: '',
          searchField: '',
          searchValue: '',
          currentPage: 1,
          dataList: [],
          totalCount: 0
        }
      };

    default:
      return state;
  }
};

export default targetAchievementReducer;
